export default {
  // Common
  catalog: "Каталог",
  login: "Войти",
  all_courses: "Все курсы",
  hand_shake: `Присоединяйтесь к нашим партнерам, зарегистрируйтесь в реферальной программе.
После регистрации вам будут предоставлены рекламные коды и ссылки.`,

  // Home page translations
  home_hero_title: "Учитесь, развивайтесь и",
  home_hero_title_2: "покоряйте новые высоты",
  home_hero_login_message: "Войдите в систему для просмотра курсов",

  // Advantages
  advantage_1:
    "Самые необходимые знания для развития сотрудников на одной платформе",
  advantage_2:
    "Возможность постоянного повышения квалификации и профессионального роста",
  advantage_3: "Индивидуальный план развития и учебные материалы",

  // Courses section
  courses_greeting: "Здравствуйте, выберите курс, который вам нравится",
  certificated_courses: "Сертифицированные курсы",
  certificated_courses_description:
    "Сертифицированные курсы состоят из малых курсов. Этот высший сертификат подтверждает, что вы овладели профессиональными знаниями в определенной области.",
  certificated_courses_empty: "Сертифицированных курсов нет!",
  courses_count: "включает курсов",

  // Status labels
  status_progress: "В процессе",
  status_finished: "Завершено",
  status_new: "Новый",
  course_downloading: "Курс загружается",
  read: "Читать",
  status_downloading: "Курс загружается",

  // Partnership
  partnership_title: "Партнерское предложение",
  join: "Присоединиться",

  // News section
  news: "Новости",
  news_description:
    "В разделе новостей вы можете узнать больше о наших курсах. Будьте в курсе образовательных и научных новостей и статей каждый день. Следите за нами, не покидая сайт Aristotel.",
  all_news: "Все новости",

  // Auth pages
  phone_or_login_placeholder: "Введите номер телефона или логин",
  phone_required: "Введите номер телефона или войдите в систему",
  password: "Пароль",
  password_required: "Введите пароль",
  forgot_password: "Забыли пароль?",
  confirmation_code_sent: "Код подтверждения отправлен на номер {phone}",
  enter_confirmation_code: "Введите код подтверждения",
  enter_another_number: "Ввести другой номер",
  enter_phone_number: "Введите номер телефона",

  // User Menu
  interests: "Интересующие меня курсы",
  exit: "Выйти",

  // Popups
  delete: "Удалить",
  cancel: "Отмена",
  want_to_logout: "Вы хотите выйти из своей учетной записи?",
  stay_on_page: "Остаться на странице",
  leave_feedback: "Оставить отзыв",
  rate_course: "Оцените курс",
  submit: "Отправить",

  // Cart
  cart: "Корзина",
  som: "Сум",
  total_value: "Общая стоимость:",
  cart_empty: "Ваша корзина пуста",
  to_purchase: "Войдите в систему для покупки",

  // Contact Page
  contact_for: "Для связи",
  your_message: "Ваше сообщение",
  name_required: "Введите ваше имя",
  email_required: "Введите E-mail",
  email_invalid: "Введите правильный E-mail",
  message_required: "Введите ваше сообщение",
  your_name: "Ваше имя",
  your_email: "Ваш e-mail",
  message_text: "Текст сообщения.....",
  leave_review_placeholder: "Оставьте отзыв.....",
  // Registration
  enter_phone: "Введите номер телефона",
  enter_your_phone: "Введите свой номер телефона.",
  enter_password: "Введите пароль",
  accept_terms: "Я принимаю условия обработки персональных данных",
  register: "Зарегистрироваться",
  have_account: "У меня есть аккаунт",

  // Course Page
  course: "курс",
  course_categories: "Категории курсов",
  more_courses: "Больше курсов",

  // User Profile
  profile: "Профиль",
  personal_info: "Личная информация",
  first_name: "Ваше имя",
  first_name_required: "Введите ваше имя",
  first_name_placeholder: "Ваше имя",
  last_name: "Отчество",
  last_name_required: "Введите отчество",
  last_name_placeholder: "Отчество",
  full_name: "Фамилия",
  full_name_required: "Введите вашу фамилию",
  full_name_placeholder: "Фамилия",
  birth_date: "Дата рождения",
  birth_date_placeholder: "Дата рождения",
  phone: "Номер телефона",
  phone_required_input: "Введите номер телефона",
  city: "Город",
  city_required: "Введите город",
  city_placeholder: "Ваш город",
  branch: "Филиал",
  branch_placeholder: "Выберите филиал",
  branch_required: "Выберите филиал",
  position: "Должность",
  position_placeholder: "Ваша должность",
  reserve: "Резерв",
  reserve_yes: "Да",
  reserve_no: "Нет",
  change_password: "Изменить пароль",
  old_password_placeholder: "Введите старый пароль",
  new_password_placeholder: "Новый пароль",
  repeat_password_placeholder: "Повторите новый пароль",
  password_min_length: "Пароль должен содержать минимум {min} символов.",
  verify: "Проверить",
  confirm: "Подтвердить",

  // User Dashboard
  my_courses: "Мои курсы",
  purchased_courses: "Купленные курсы",
  studying_courses: "Изучаемые курсы",
  completed_courses: "Завершенные курсы",
  certificates: "Сертификаты",
  no_courses_started: "Вы еще не начали ни одного курса!",
  wishlist: "Интересующие курсы",
  no_wishlist: "Список курсов не найден",
  my_certificates: "Мои сертификаты",
  bonuses: "Бонусы",

  // Promo codes
  promo_codes: "Промо коды",
  enter_promo_code: "Введите промо код",
  promo_code_length_error: "Длина кода слишком короткая или длинная",
  enter: "Ввести",

  // Notifications
  notifications: "Уведомления",
  no_notifications: "Нет сообщений",

  // Cards
  my_cards: "Номера моих карт",
  add_new_card: "Добавить новую карту",
  card_number: "Введите номер карты",
  card_number_error: "Введите правильный номер карты",
  card_expiry: "Введите срок действия карты",
  card_expiry_error: "Введите правильный срок действия карты",
  enter_code: "Введите код",
  code_error: "Введите правильный код",

  // Invite Friends
  invite_friends: "Пригласить друга",
  copy_referral_code: "Нажмите, чтобы скопировать реферальный код",
  for_website: "Для сайта",
  for_mobile: "Для мобильных устройств",
  how_to_earn_bonus: "Что нужно сделать, чтобы получить бонус",
  step_1: "Отправьте скопированную ссылку другу",
  step_2: "Ваш друг должен зарегистрироваться",
  step_3: "Ваш друг должен купить один из наших курсов",

  // Contact
  contact: "Контакты",

  // Lesson Layout
  share: "Поделиться",
  course_content: "Содержание курса",
  final_test: "Итоговый тест",

  // Course Single
  lessons: "уроков",
  lessons_upper: "УРОКОВ",
  lessons_header: "Уроки",
  share_opinion: "Поделиться",
  leave_comment: "Оставить отзыв",
  course_includes: "Этот курс включает в себя",
  you_may_also_like: "Вам также может понравиться",
  save: "Сохранить",
  saved: "Сохранено",
  course_materials: "Материалы курса",

  // Certified Courses
  need_complete_all_courses:
    "Для получения основного сертификата вам необходимо завершить все курсы. Тест пока закрыт.",
  courses_completed_take_test:
    "Все курсы завершены! Теперь вы можете пройти сертификационный тест.",
  test_passed_successfully: "Вы успешно прошли сертификационный экзамен.",
  test_passed: "Тест пройден",
  test_not_created: "Тест для этого курса еще не создан.",
  course_loading: "Курс загружается...",
  in_progress: "В разработке",
  certificate_description:
    'После успешного завершения всех малых курсов в составе сертифицированного курса вам необходимо пройти итоговый специальный тест. После успешной сдачи итогового теста вы получите специальный высокий сертификат. Сертификат можно скачать в разделе "Мои сертификаты".',
  start_test: "Начать тест",

  // Footer
  address: "Узбекистан, Ферганская область, г. Коканд, ул. Шохрухобод",

  // Navigation
  news_and_discounts: "Новости и скидки",
  back_to_courses: "Все курсы",

  // Footer
  instructions: "Инструкции",

  // Course page
  all_courses_link: "Все курсы",
  course_lessons: "Уроки",
  description: "Описание",
  author: "Автор:",
  last_update: "Последнее обновление:",
  subscribers_count: "Количество подписчиков:",
  details: "Подробнее",

  // Lesson page
  next: "Следующий",
  to_test: "К тесту",
  to_final_test: "К финальному тесту",
  ready: "Готово",
  next_lesson: "следующий урок",
  passed_test: "Вы прошли тест",
  congratulations: "Поздравляем!",
  course_completed: "Вы успешно завершили курс!",
  certificate_received: "Сертификат получен!",
  certificate_notification:
    "Вы награждены сертификатом в связи с успешным завершением курса.",
  go_to_profile: "Перейти в профиль",
  view_certificate: "Посмотреть сертификат",

  // Certificate page
  my_certificates_desc:
    "Сертификаты всех завершенных курсов появятся на этой странице.",

  // Bonus page
  bonus: "Бонус",
  withdraw: "Вывести",

  // News page
  last_news_update: "Последнее обновление:",
  today: "сегодня",
  days_ago: "дней назад",

  // Course page additional
  average_rating: "Средний рейтинг",
  no_reviews: "Нет отзывов об этом курсе.",
  more_reviews: "больше отзывов",
  unlimited_access: "Неограниченный доступ",
  certificate: "Сертификат",
  go_to_course: "Перейти к курсу",

  // 404 page
  page_not_found: "страница не найдена",
  back: "назад",
  go_to_main: "На главную",

  // Checkout page (Cart2)
  checkout_title: "ОФОРМЛЕНИЕ ЗАКАЗА",
  payment: "Оплата",
  card_payment: "Оплата картой",
  wallet_payment: "Оплата с кошелька",
  select_card_for_payment: "Выберите карту для оплаты",
  no_card_add_prompt: "У вас нет карты. Нажмите, чтобы добавить карту",
  pay: "оплатить",

  // Certificate check page
  certificate_info: "Информация о полученном сертификате",
  no_certificate_info_found: "Информация о сертификате не найдена",
  confirmed: "Подтверждено!",
  certificate_confirmation_text:
    'Онлайн платформа "Universalbank Akademiyasi" подтверждает, что {user_name} {date} успешно завершил(а) сертифицированный курс {course_name} и данный сертификат является подлинным!',
  certificate_confirmation_mini_text:
    'Онлайн платформа "Universalbank Akademiyasi" подтверждает, что {user_name} {date} успешно завершил(а) мини-курс {course_name} и данное удостоверение является подлинным!',
  view_certificate_link: "Посмотреть сертификат",

  // Auth placeholders
  password_placeholder: "Пароль",
  enter_code_placeholder: "Введите код",
  repeat_password_input_placeholder: "Повторите пароль",
  new_password_repeat_placeholder: "Повторите пароль",
  passwords_not_match: "Пароли не совпадают",

  // Test pages
  my_office: "Мой кабинет",
  questions_count: "Количество вопросов:",
  attempts_count: "Количество попыток",
  previous_question: "предыдущий вопрос",
  finish_test: "Завершить",
  next_question: "Следующий вопрос",
  retake_test: "Пересдать тест",
  start: "НАЧАТЬ",
  intermediate_test_passed:
    "Вы успешно прошли промежуточный тест курса {course}.",

  // Mobile bar
  home: "Главная",
  courses: "Курсы",

  // MyCard page
  card_number_placeholder: "Номер карты",
  card_expiry_placeholder: "Срок действия карты",
  sms_code_sent: "SMS код подтверждения",
  sms_code_sent_to: "отправлен на номер {phone}",
  code_input_placeholder: "Введите код",
  delete_card_confirm:
    "Вы действительно хотите отвязать карту? Если вы удалите, вы не сможете повторно привязать эту карту",

  // Notification
  no_new_notifications: "У вас нет новых уведомлений",

  // Certified course
  no_certificated_courses: "Сертифицированных курсов нет!",

  // Promo codes
  code_placeholder: "Код",

  // Lesson layout
  lessons_count_label: "УРОКОВ",

  // Delete course popup
  delete_course_confirm: "Вы хотите удалить курс?",

  // Прокторинг
  proctoring_loading: "Подготовка сеанса наблюдения…",
  proctoring_finished: "Сеанс наблюдения завершён.",
  proctoring_retry: "Повторить",
  proctoring_error_sdk:
    "Не удалось загрузить систему наблюдения. Проверьте подключение к интернету.",
  proctoring_error_token:
    "Сеанс наблюдения не подтверждён. Обновите страницу и попробуйте снова.",
  proctoring_error_permissions:
    "Чтобы начать тест, разрешите доступ к камере, микрофону и экрану.",
  proctoring_error_generic:
    "Не удалось начать сеанс наблюдения. Попробуйте ещё раз.",
};
